// Shared by child badges and the Hide Completed filter. Exact personal
// assignments take precedence; legacy type-level assignments use quote status.
export const getChildAssignmentStatus = (job, quote, userId) => {
    const designers = (job.job_designers || []).filter(d =>
        d.user_id === userId && d.quote_type === quote.quote_type && d.child_job_id === quote.id
    );
    if (designers.length) {
        return {
            isCompleted: designers.every(d => !!d.is_completed),
            isStarted: designers.some(d => !!d.is_started),
        };
    }
    return {
        isCompleted: quote.design_status === 'completed',
        isStarted: quote.design_status === 'in_progress',
    };
};

export const buildMyAssignmentItems = (jobs, userId) => {
        const items = [];
        jobs.forEach(job => {
            // Child departments = job_quotes with child_unique_id (display name) set, not redeliveries
            const allChildQuotes = job.job_quotes?.filter(
                q => q.child_unique_id &&
                    (q.delivery_count === null || q.delivery_count === 0 || q.delivery_count === undefined)
            ) || [];
            const childQuotes = allChildQuotes.filter(q => q.is_required === true);
            const isNewSystem = allChildQuotes.length > 0;

            if (isNewSystem) {
                const userDesigners = job.job_designers?.filter(d => d.user_id === userId) || [];

                // New-system: user is assigned to a specific child via child_job_id (= job_quotes.id)
                const userChildIds = new Set(
                    userDesigners.filter(d => d.child_job_id).map(d => d.child_job_id)
                );
                // Fallback: assignment rows without child_job_id apply to whole quote type
                const userParentQuoteTypes = new Set(
                    userDesigners.filter(d => !d.child_job_id).map(d => d.quote_type)
                );

                // Quote types that have child departments
                const childQuoteTypes = new Set(allChildQuotes.map(q => q.quote_type));

                // Parent card only if user has a type-level assignment NOT covered by children
                const estimators = Array.isArray(job.job_estimators)
                    ? job.job_estimators : [job.job_estimators].filter(Boolean);
                const userIsEstimator = estimators.some(e => e.user_id === userId);
                const userHasParentDesign = [...userParentQuoteTypes].some(t => !childQuoteTypes.has(t));
                if (userHasParentDesign || userIsEstimator) {
                    items.push({ type: 'parent', job, quote: null });
                }

                // Child card only for children the user is specifically assigned to
                childQuotes.forEach(quote => {
                    if (userChildIds.has(quote.id) || userParentQuoteTypes.has(quote.quote_type)) {
                        items.push({ type: 'child', job, quote });
                    }
                });
            } else {
                items.push({ type: 'old', job, quote: null });
            }
        });
        return items;
    };

